<div class="card bg-dark-lighter text-white">
  <div class="card-body">
    <div
      class="profit-chart"
      echarts
      [options]="chartOption"
      [merge]="updateChartOption"
      (chartClick)="onChartClick($event)"
      (chartDataZoom)="zoom($event)"
    ></div>
    <div class="container">
      <div class="row">
        <div class="pos-relative col-md-4 col-sm-6" *ngFor="let opt of lines">
          <label class="rox-checkbox blue x20">
            <input type="checkbox" (change)="onSelectExchange()" [(ngModel)]="opt.selected"/>
            <span class="checkmark"></span>
            <fx-chart-icon [options]="opt"></fx-chart-icon>
            <span>{{ opt.text }}</span>
          </label>
        </div>
      </div>
    </div>
  </div>
</div>
